import * as React from "react";
import { useTableKindId } from "../../newcomponents/table/data/useTableKindId";
import { useTableItemQueryData } from "../../newcomponents/table/data/useTableItemQueryData";
import { Table } from "../../newcomponents/table/table";
import { TableNewItemButton } from "../../newcomponents/table/components/tableNewButton";
import { TableHeaderRefreshButton } from "../../newcomponents/table/components/RefreshButton";
import { CustomTableCPLNQuery } from "../../newcomponents/table/components/TableCplnQuery";
import { NameDescriptionColumn } from "../../newcomponents/table/columns/wellKnown/nameDescriptionColumn";
import { TagsColumn } from "../../newcomponents/table/columns/wellKnown/tagsColumn";
import { CreatedColumn } from "../../newcomponents/table/columns/wellKnown/createdColumn";
import { LastModifiedColumn } from "../../newcomponents/table/columns/wellKnown/lastModifiedColumn";
import { CloudAccount } from "../../schema/types/cloudaccount/entity";
import { TableActionsDropdown } from "../../newcomponents/table/components/tableActionsDropdown";
import { DeleteModal } from "../../components/modals/deleteModal";
import { ProviderColumn } from "../../newcomponents/table/columns/wellKnown/providerColumn";
import { CloudAccountTableItem, getCloudAccountTableItem } from "../../mst/kinds/cloudaccount.helpers";
import { useColumnsWithTagColumns } from "../../newcomponents/table/columns/tagColumns/useColumnsWithTagColumns";

export const CloudAccountList: React.FC = () => {
  const [selectedLinks, setSelectedLinks] = React.useState<string[]>([]);
  const [action, setAction] = React.useState<string>("");

  const { kind, id } = useTableKindId("cloudaccount", "cloudaccount-list");
  const qData = useTableItemQueryData<CloudAccount>(kind, {});
  const columns = useColumnsWithTagColumns<CloudAccountTableItem>(
    [NameDescriptionColumn(), ProviderColumn(), TagsColumn(), CreatedColumn(), LastModifiedColumn()],
    kind,
  );

  const cloudaccountTableItems: CloudAccountTableItem[] = qData.visibleItems.map((item) =>
    getCloudAccountTableItem({ item: item }),
  );

  return (
    <>
      <Table<CloudAccountTableItem>
        title={"Cloud Accounts"}
        data={cloudaccountTableItems}
        selectKey="selfLink"
        selectMode="multi"
        selections={selectedLinks}
        onSelectionsChange={setSelectedLinks}
        tableId={id}
        headerRenderer={() => {
          return (
            <>
              <TableNewItemButton kind={kind} />
              <TableActionsDropdown
                kind={kind}
                selectionLinks={selectedLinks}
                options={[
                  {
                    key: "delete",
                    label: "Delete",
                    disabled: selectedLinks.length < 1,
                    danger: true,
                    callback: () => setAction("delete"),
                  },
                ]}
              />
              <TableHeaderRefreshButton onClick={qData.refetch} />
              <CustomTableCPLNQuery
                tableId={id}
                kind={kind}
                onQuery={qData.setCplnQuery}
                isLoading={qData.isLoading}
              />
            </>
          );
        }}
        enableFilter
        isLoading={qData.isLoading}
        onSortChange={qData.setSort}
        onSearchChange={qData.setSearch}
        isLoadingMore={qData.isLoadingMore}
        hasMore={qData.hasMore}
        onLoadMore={qData.fetchNextPage}
        columns={columns}
      />
      {action === "delete" ? (
        <DeleteModal
          kind={kind}
          onCancel={() => setAction("")}
          onComplete={() => {
            setAction("");
            setSelectedLinks([]);
            qData.refetch();
          }}
          links={selectedLinks}
        />
      ) : null}
    </>
  );
};
